import styled from '@emotion/styled'

export const StyledFields = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px;
`